import { S3FoldersType } from "@cryptors/api-client";
import {
  Control,
  Controller,
  FieldPathByValue,
  FieldValues,
  UseFormSetError,
} from "react-hook-form";

import { upload } from "@/utils/upload";

import UploadButton from "./UploadButton";

type UploadValue = string | null | undefined;

type UploadPath<T extends FieldValues> = FieldPathByValue<T, UploadValue>;

interface UploadFieldProps<T extends FieldValues, TName extends UploadPath<T>> {
  control: Control<T>;
  setError: UseFormSetError<T>;
  s3FoldersType: S3FoldersType;
  name: TName;
  uploadButtonLabel: string;
  accept?: string;
  optional?: boolean;
}

const UploadField = <T extends FieldValues, TName extends UploadPath<T>>({
  control,
  setError,
  s3FoldersType,
  name,
  uploadButtonLabel,
  accept,
  optional,
}: UploadFieldProps<T, TName>) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={optional ? undefined : { required: "Ce champ est requis" }}
      render={({ field, fieldState }) => (
        <UploadButton
          id={name}
          inputSrc={field.value}
          uploadButtonLabel={uploadButtonLabel}
          accept={accept}
          onError={() =>
            setError(name, {
              message: "L'upload a échoué. Veuillez réessayer",
            })
          }
          errorMessage={fieldState.error?.message}
          onChange={async (event) => {
            const url = await upload(event, s3FoldersType);
            field.onChange(url);
          }}
          onDelete={() => field.onChange(null)}
        />
      )}
    />
  );
};

export default UploadField;
